
import React from 'react';
import { Link } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function PrintTile({mediaUrl, articleUrl}) {


  return (
    <div className='bs-print-tile'>
        {/* <Link to={articleUrl} target='_blank' className='bs-print-tile__link'>Link</Link> */}
        <div className='bs-print-tile__image-wrap'>
        <Zoom>
          <CloudinaryAdvancedImage imagePublicId={mediaUrl} className='bs-print-tile__image' type="section-feature-image" />
        </Zoom>
        </div>
    </div>
  )
}

export default PrintTile